export default "__VITE_ASSET__45855476__"